import Text from 'components/Text/Text';

import './Stat.scss';

interface IProps {
  type: string;
  value: number;
}

const Stat = ({type = 'promotions', value = 14}: IProps) => {
  const setType = () => {
    switch (type) {
      case 'generated-posts':
        return 'Promotions';
      case 'on-tap':
        return 'Beers on tap';
      case 'beer-styles':
        return 'Beer styles';
      case 'pubs':
        return 'Pubs';
      case 'breweries':
        return 'Breweries';
      case 'beers':
        return 'Beers';
      default:
        return '';
    }
  };

  return (
    <div className="stat col-3">
      <div className="stat__number">
        <Text tag="span">{value}</Text>
      </div>
      <div className="stat__title">
        <Text tag="h4" uppercase>
          {setType()}
        </Text>
      </div>
    </div>
  );
};

export default Stat;
